export default {
  SET_REPLIQUES_NFE_TABLE_ITEMS(state, payload) {
    state.repliquesNFeTableItems = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
